import { store } from '../store/store';
import { HttpRequest } from '../utils';

const httpRequest = new HttpRequest(store);

export const init = async () => {
  const res = await httpRequest.get('/api/general/init');
  return {
    ...res,
    engineCapacities: (res?.engineCapacities || []).map((item: any) => ({
        ...item,
        value: undefined,
      })),
  };
};
